import FloatLabel from 'lib/float_label'

FloatLabel('.form-group');
